import React, { useState } from 'react';
import { subscriberAPI } from '../../Api/api';
import { useAppLanguage } from '../../Hooks/useAppLanguage';
import Button from '../../Component/UI/Button/Button';
import './Subscribe.css';

/**
 * Dedicated newsletter landing page for shareable campaign links:
 * /subscribe or /:lang/subscribe
 */
const Subscribe = () => {
    const { t, dir } = useAppLanguage();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');

    const handleSubscribe = async (event) => {
        event.preventDefault();
        if (!email.trim()) return;

        setStatus('loading');
        setMessage('');

        try {
            const response = await subscriberAPI.subscribe(email.trim(), 'subscribe-page');
            setStatus('success');
            setMessage(response.data?.message || t('subscribe.success'));
            setEmail('');
        } catch (error) {
            setStatus('error');
            setMessage(error.response?.data?.message || t('subscribe.error'));
        }
    };

    return (
        <main className="main">
            <section className="subscribe-section section">
                <div className="container" dir={dir}>
                    <div className="subscribe-card">
                        {status === 'success' ? (
                            <div>
                                <div className="subscribe-success-visual" aria-hidden="true">
                                    <span className="subscribe-success-icon">&#10003;</span>
                                </div>
                                <h1 className="subscribe-title">{t('subscribe.doneTitle')}</h1>
                                <p className="subscribe-lead">{message}</p>
                            </div>
                        ) : (
                            <>
                                <h1 className="subscribe-title">{t('subscribe.title')}</h1>
                                <p className="subscribe-lead">{t('subscribe.description')}</p>

                                <form className="subscribe-form" onSubmit={handleSubscribe} noValidate>
                                    <div>
                                        <label className="subscribe-label" htmlFor="subscribe-email">
                                            {t('subscribe.emailLabel')}
                                        </label>
                                        <input
                                            id="subscribe-email"
                                            type="email"
                                            className="subscribe-input"
                                            placeholder={t('subscribe.emailPlaceholder')}
                                            value={email}
                                            onChange={(event) => setEmail(event.target.value)}
                                            required
                                            disabled={status === 'loading'}
                                            autoComplete="email"
                                        />
                                    </div>
                                    <Button
                                        type="submit"
                                        className="subscribe-submit"
                                        disabled={status === 'loading' || !email.trim()}
                                    >
                                        {status === 'loading'
                                            ? t('subscribe.processing')
                                            : t('subscribe.confirm')}
                                    </Button>
                                </form>

                                {status === 'error' && (
                                    <p className="subscribe-alert" role="alert">
                                        {message}
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Subscribe;
